import DocPage from '../components/DocPage.jsx'
import { docsEvents } from '../content.js'

// /docs/events — P6-105. The first of P6-104's three empty slots to become a
// real page, and the one the restructure was most obviously missing: /squadup
// registers twelve nodes and nothing on this site had ever named one.
//
// Four lines, like DocsMovieNight.jsx and Explainer.jsx, because the page TYPE
// already existed. See content-src/docs-events.json for what is on it and, more
// usefully, for the list of things it deliberately does not say.

export default function DocsEvents() {
  return <DocPage doc={docsEvents} />
}
